<div>
  <div class="prose">
    <h1>Licenses</h1>
  </div>

  @if (errorFetchingLicenses) {
    <div class="mt-4">
      <p class="text-error">{{ errorFetchingLicenses }}</p>
    </div>
  } @else if (loadingLicenses) {
    <div class="mt-4 flex justify-center">
      <div class="loading loading-spinner loading-lg"></div>
    </div>
  } @else if (!licenses) {
    <div class="mt-4 text-center text-error">
      <p>Error fetching licenses</p>
    </div>
  } @else {
    <div class="mt-8">
      <div class="mb-4 flex w-full justify-between">
        <div class="prose">
          <h2 class="ml-6">Active</h2>
        </div>
      </div>

      <div
        class="hidden overflow-x-auto rounded-lg border border-base-content/20 sm:block"
      >
        <table
          class="table table-zebra table-pin-rows table-pin-cols table-lg static"
        >
          <thead class="text-base font-medium">
            <tr>
              <td>Product/Service</td>
              <td>Type</td>
              <td>Expiration Date</td>
              <td class="w-56"></td>
            </tr>
          </thead>
          <tbody>
            @for (
              license of licenses.active;
              track license.id;
              let i = $index
            ) {
              <tr>
                <td>{{ license.product.title }}</td>
                <td>
                  {{ getLicenseType(license) }}
                </td>
                <td [ngClass]="{ 'text-error': license.close_to_expiration }">
                  {{ license.expiration | date: 'MM/dd/yyyy' : 'UTC' }}
                </td>
                <td class="w-56 text-end">
                  @if (isInCart(license)) {
                    <div class="flex items-center justify-between">
                      <p class="italic text-base-content/70">In Cart</p>
                      <button
                        class="btn btn-outline btn-sm w-28"
                        [routerLink]="['/cart']"
                      >
                        View Cart
                      </button>
                    </div>
                  } @else if (
                    userCanCreateInvoice && !pendingInvoiceHasManualValues
                  ) {
                    <button
                      class="btn btn-primary btn-sm w-28"
                      (click)="addLicenseToCart(license)"
                      [disabled]="addingLicensesToCart"
                    >
                      @if (
                        addingLicensesToCart &&
                        licenseBeingAddedToCart?.id === license.id
                      ) {
                        <span
                          class="loading loading-spinner loading-sm absolute"
                        ></span>
                      }
                      Add to Cart
                    </button>
                  }
                </td>
              </tr>
            } @empty {
              <tr>
                <td
                  class="text-center"
                  [attr.colspan]="userCanCreateInvoice ? 4 : 3"
                >
                  <div class="flex justify-center">
                    <div>No active licenses</div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Mobile Active Licenses -->
      <div class="sm:hidden">
        @for (license of licenses.active; track license.id; let i = $index) {
          <div class="my-2 w-full rounded-lg border border-base-content/20 p-4">
            <div class="justify-self-end"></div>
            <div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Product:</p>
                <p>{{ license.product.title }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Active:</p>
                <p>{{ license.active ? 'Yes' : 'No' }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Type:</p>
                <p>
                  {{ getLicenseType(license) }}
                </p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Expiration Date:</p>
                <p>
                  {{ license.expiration | date: 'MM/dd/yyyy' : 'UTC' }}
                </p>
              </div>
              <div class="mt-2 flex">
                @if (isInCart(license)) {
                  <div class="flex w-full items-center justify-between">
                    <button
                      class="btn btn-outline btn-sm w-28"
                      [routerLink]="['/cart']"
                      [disabled]="addingLicensesToCart"
                    >
                      <!-- <app-cart-icon
                        class="inline-block h-6 w-6"
                      ></app-cart-icon> -->
                      View Cart
                    </button>
                    <p class="italic text-base-content">In Cart</p>
                  </div>
                } @else {
                  <button
                    class="btn btn-primary btn-sm w-28"
                    (click)="addLicenseToCart(license)"
                    [disabled]="addingLicensesToCart"
                  >
                    @if (addingLicensesToCart) {
                      <span
                        class="loading loading-spinner loading-sm absolute"
                      ></span>
                    }
                    <!-- <app-plus-icon class="inline-block h-6 w-6"></app-plus-icon> -->
                    Add to Cart
                  </button>
                }
              </div>
            </div>
          </div>
        } @empty {
          <div class="w-full text-center">
            <p>No active licenses</p>
          </div>
        }
      </div>
    </div>

    @if (licenses.pending.length > 0) {
      <div class="pt-12">
        <div class="prose">
          <h2 class="mb-4 ml-6">Pending</h2>
        </div>
        <div
          class="hidden overflow-x-auto rounded-lg border border-base-content/20 sm:block"
        >
          <table
            class="table table-zebra table-pin-rows table-pin-cols table-lg static"
          >
            <thead class="text-base font-medium">
              <tr>
                <td>Product/Service</td>
                <td>Type</td>
                <td>Expiration Date</td>
              </tr>
            </thead>
            <tbody>
              @for (license of licenses.pending; track license.id) {
                <tr>
                  <td>{{ license.product.title }}</td>
                  <td>
                    {{ getLicenseType(license) }}
                  </td>
                  <td>
                    {{ license.expiration | date: 'MM/dd/yyyy' : 'UTC' }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Mobile Pending Licenses -->
        <div class="sm:hidden">
          @for (license of licenses.pending; track license.id) {
            <div
              class="my-2 w-full rounded-lg border border-base-content/20 p-4"
            >
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Product:</p>
                <p>{{ license.product.title }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Active:</p>
                <p>{{ license.active ? 'Yes' : 'No' }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Type:</p>
                <p>
                  {{ getLicenseType(license) }}
                </p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Expiration Date:</p>
                <p>
                  {{ license.expiration | date: 'MM/dd/yyyy' : 'UTC' }}
                </p>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (licenses.expired.length > 0) {
      <div class="pt-12">
        <div class="prose">
          <h2 class="mb-4 ml-6">Expired</h2>
        </div>
        <div
          class="hidden overflow-x-auto rounded-lg border border-base-content/20 sm:block"
        >
          <table
            class="table table-zebra table-pin-rows table-pin-cols table-lg static"
          >
            <thead class="text-base font-medium">
              <tr>
                <th>Product/Service</th>
                <th>Type</th>
                <th>Expiration Date</th>
              </tr>
            </thead>
            <tbody>
              @for (license of licenses.expired; track license.id) {
                <tr>
                  <td>{{ license.product.title }}</td>
                  <td>
                    {{ getLicenseType(license) }}
                  </td>
                  <td>
                    {{ license.expiration | date: 'MM/dd/yyyy' : 'UTC' }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Mobile Expired Licenses -->
        <div class="sm:hidden">
          @for (license of licenses.expired; track license.id) {
            <div
              class="my-2 w-full rounded-lg border border-base-content/20 p-4"
            >
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Product:</p>
                <p>{{ license.product.title }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Active:</p>
                <p>{{ license.active ? 'Yes' : 'No' }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Type:</p>
                <p>
                  {{ getLicenseType(license) }}
                </p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Expiration Date:</p>
                <p>
                  {{ license.expiration | date: 'MM/dd/yyyy' : 'UTC' }}
                </p>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (licenses.disabled.length > 0) {
      <div class="pt-12">
        <div class="prose">
          <h2 class="mb-4 ml-6">Disabled</h2>
        </div>
        <div
          class="hidden overflow-x-auto rounded-lg border border-base-content/20 sm:block"
        >
          <table
            class="table table-zebra table-pin-rows table-pin-cols table-lg static"
          >
            <thead class="text-base font-medium">
              <tr>
                <th>Product/Service</th>
                <th>Type</th>
                <th>Expiration Date</th>
              </tr>
            </thead>
            <tbody>
              @for (license of licenses.disabled; track license.id) {
                <tr>
                  <td>{{ license.product.title }}</td>
                  <td>
                    {{ getLicenseType(license) }}
                  </td>
                  <td>
                    {{ license.expiration | date: 'MM/dd/yyyy' : 'UTC' }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Mobile Disabled Licenses -->
        <div class="sm:hidden">
          @for (license of licenses.disabled; track license.id) {
            <div
              class="my-2 w-full rounded-lg border border-base-content/20 p-4"
            >
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Product:</p>
                <p>{{ license.product.title }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Active:</p>
                <p>{{ license.active ? 'Yes' : 'No' }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Type:</p>
                <p>
                  {{ getLicenseType(license) }}
                </p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Expiration Date:</p>
                <p>
                  {{ license.expiration | date: 'MM/dd/yyyy' : 'UTC' }}
                </p>
              </div>
            </div>
          }
        </div>
      </div>
    }
  }
</div>


<!-- Temporarily hidden license views with activation keys and transfers -->
<!-- <div class="mt-8">
  <div
    class="mb-4 flex w-full flex-wrap items-center justify-between gap-2"
  >
    <div class="prose">
      <h2 class="ml-6">Active</h2>
    </div>
  </div>

  <div class="overflow-hidden rounded-lg border border-base-content/20">
    <div class="divide-y divide-base-300">
      @for (license of licenses.active; track license.id; let i = $index) {
        <article
          class="license-row px-4 py-4"
          [ngClass]="{ 'bg-base-200': i % 2 === 0 }"
        >
          <div
            class="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between"
          >
            <div
              class="grid min-w-0 flex-1 grid-cols-2 gap-x-6 gap-y-4 lg:grid-cols-3 xl:grid-cols-5"
            >
              <div class="col-span-2 min-w-0 lg:col-span-3 xl:col-span-2">
                <div class="field-label">Product</div>
                <div class="break-words text-base font-medium">
                  {{ license.product.code }} -
                  {{ license.product.title }} ({{
                    license.product.variance_code
                  }})
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Type</div>
                <div class="break-words text-base">
                  {{ getLicenseType(license) }}
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Duration</div>
                <div class="break-words text-base">
                  {{ license.product_variant.display_duration }}
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Expiration</div>
                <div
                  class="break-words text-base"
                  [ngClass]="{ 'text-error': license.close_to_expiration }"
                >
                  {{ license.expiration | date: 'MM/dd/YYYY' : 'UTC' }}
                </div>
              </div>

              <div class="col-span-2 min-w-0 lg:col-span-3 xl:col-span-2">
                <div class="field-label">
                  Activation Key
                  @if (license.activation_key) {
                    @if (shownKeys.has(license.id)) {
                      <app-eye-slash-icon
                        (click)="shownKeys.delete(license.id)"
                        class="mb-[-4px] ml-2 inline-block h-4 w-4 cursor-pointer"
                      />
                    } @else {
                      <app-eye-icon
                        (click)="shownKeys.add(license.id)"
                        class="mb-[-4px] ml-2 inline-block h-4 w-4 cursor-pointer"
                      />
                    }
                  }
                </div>
                <div class="break-words text-base">
                  @if (license.activation_key) {
                    @if (shownKeys.has(license.id)) {
                      <span class="text-nowrap text-sm">{{
                        license.activation_key.activation_key
                      }}</span>
                    } @else {
                      <span [innerHTML]="hiddenKeyString"></span>
                    }
                  } @else {
                    <span class="text-base italic">None</span>
                  }
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Unique ID</div>
                <div class="break-words text-base">
                  @if (license.activation_key) {
                    {{ license.activation_key.unique_id || '—' }}
                  } @else {
                    <span
                      class="link"
                      (click)="showInitialUniqueIDDialog()"
                    >
                      Enter Unique ID
                    </span>
                  }
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">transfers left</div>
                <div class="break-words text-base">
                  {{ license.transfers_left }}
                </div>
              </div>
            </div>

            <div class="ml-auto lg:ml-0">
              <div class="flex h-[42px] w-44 justify-end">
                @if (isInCart(license)) {
                  <div class="flex items-center justify-end">
                    <p class="mr-2 italic text-base-content/70">In Cart</p>
                    <button
                      class="btn btn-outline btn-sm w-28"
                      [routerLink]="['/cart']"
                    >
                      View Cart
                    </button>
                  </div>
                } @else if (
                  userCanCreateInvoice && !pendingInvoiceHasManualValues
                ) {
                  <button
                    class="btn btn-primary btn-sm w-28"
                    (click)="addLicenseToCart(license)"
                    [disabled]="addingLicensesToCart"
                  >
                    @if (
                      addingLicensesToCart &&
                      licenseBeingAddedToCart?.id === license.id
                    ) {
                      <span
                        class="loading loading-spinner loading-sm absolute"
                      ></span>
                    }
                    Add to Cart
                  </button>
                }
              </div>
              <div class="mt-4 flex h-[42px] w-44 justify-end">
                @if (license.unique_id && license.transfers_left > 0) {
                  <button
                    type="button"
                    class="btn btn-outline btn-sm w-28"
                    (click)="showTransferDialog(license)"
                  >
                    Transfer
                  </button>
                }
              </div>
            </div>
          </div>
        </article>
      } @empty {
        <div
          class="bg-base-200/30 px-4 py-8 text-center text-base-content/70"
        >
          No active licenses
        </div>
      }
    </div>
  </div>
</div>

<dialog class="modal" #assignInitialUniqueIDDialog>
  <div class="modal-box max-h-[90vh] max-w-5xl overflow-y-auto">
    <form method="dialog">
      <button
        class="btn btn-circle btn-ghost btn-sm absolute right-2 top-2"
      >
        ✕
      </button>
    </form>

    <h3 class="text-lg font-bold">Apply Initial Unique IDs</h3>

    @if (errorFetchingMachines) {
      <p class="text-error">Unable to load active machines</p>
    } @else if (loadingMachines) {
      <div class="skeleton h-24 w-full"></div>
    } @else if (distinctActiveMachines.length > 0) {
      <p class="mt-4">
        Copy a Unique ID from active machines below, then paste into each
        license row.
      </p>

      <div class="my-4">
        <h4 class="mb-2 font-medium">Active Machines</h4>
        @if (distinctActiveMachines.length === 0) {
          <p class="text-sm opacity-70">No active machines found.</p>
        } @else {
          <div class="overflow-x-auto rounded-lg border border-base-content/20">
            <table class="table table-zebra table-sm">
              <thead class="text-sm">
                <tr>
                  <th class="w-[1%]"></th>
                  <th class="font-medium">Unique ID</th>
                  <th class="font-medium">Name</th>
                  <th class="font-medium">Last used</th>
                </tr>
              </thead>
              <tbody>
                @for (
                  machine of distinctActiveMachines;
                  track machine.registration_id
                ) {
                  <tr>
                    <td class="w-[1%]">
                      <span
                        class="inline-flex"
                        [ngClass]="
                          copyFeedbackRegistrationId ===
                          machine.registration_id
                            ? 'tooltip tooltip-top tooltip-open'
                            : ''
                        "
                        [attr.data-tip]="
                          copyFeedbackRegistrationId ===
                          machine.registration_id
                            ? 'Copied!'
                            : null
                        "
                      >
                        <button
                          type="button"
                          class="btn btn-outline btn-xs shrink-0 flex-nowrap gap-1"
                          (click)="
                            copyMachineUniqueId(
                              machine.uniqueid,
                              machine.registration_id
                            )
                          "
                        >
                          <app-file-copy-icon
                            class="h-4 w-4"
                          ></app-file-copy-icon>
                          Copy
                        </button>
                      </span>
                    </td>
                    <td class="max-w-md">
                      <div
                        class="flex min-w-0 items-center justify-between gap-2"
                      >
                        <span class="truncate font-mono text-xs">{{
                          machine.uniqueid
                        }}</span>
                      </div>
                    </td>
                    <td>{{ machine.computername ?? '—' }}</td>
                    <td>{{ machine.lastused ?? '—' }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    }

    <div class="my-4">
      <h4 class="mb-2 font-medium">Licenses</h4>
      <div class="overflow-x-auto rounded-lg border border-base-content/20">
        <table class="table table-zebra table-sm">
          <thead class="text-sm">
            <tr>
              <th class="font-medium">Product</th>
              <th class="font-medium">Type</th>
              <th class="min-w-[14rem] font-medium">Unique ID</th>
            </tr>
          </thead>
          <tbody>
            @for (
              license of activeLicensesWithoutUniqueIDs;
              track license.id
            ) {
              <tr>
                <td>{{ license.product.title }}</td>
                <td>{{ getLicenseType(license) }}</td>
                <td>
                  <div class="flex flex-wrap items-center gap-2">
                    <input
                      type="text"
                      class="input input-sm input-bordered min-w-[12rem] flex-1 font-mono text-xs"
                      placeholder="Paste or type Unique ID"
                      [ngModel]="initialUniqueIDs[license.id]"
                      (ngModelChange)="
                        handleInitialUniqueIDChange($event, license)
                      "
                    />
                    <button
                      type="button"
                      class="btn btn-outline btn-sm shrink-0 gap-1"
                      (click)="pasteUniqueIdIntoLicense(license)"
                    >
                      <app-clipboard-icon
                        class="h-4 w-4 text-current"
                      ></app-clipboard-icon>
                      Paste
                    </button>
                  </div>
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="3" class="text-center italic opacity-70">
                  No licenses without Unique IDs
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <p class="my-2 text-sm text-warning opacity-70">
      * This process will apply the entered Unique IDs to your licenses. If
      you wish to tranfer licenses to another machine afterwards, those
      transfers will count against your annual license transfer limit (6
      transfers per year).
    </p>

    <div
      class="mt-4 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"
    >
      <div class="flex shrink-0 justify-end gap-2">
        @if (applyingInitialUniqueIds) {
          <span class="loading loading-spinner loading-sm"></span>
        }
        <button
          class="btn btn-primary"
          [disabled]="applyingInitialUniqueIds"
          (click)="applyInitialUniqueIDs()"
        >
          Apply
        </button>
        <button
          class="btn btn-neutral"
          (click)="closeAssignInitialUniqueIDDialog()"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</dialog>

<dialog #transferDialog class="modal">
  <div class="modal-box max-w-3xl">
    <form method="dialog">
      <button
        type="button"
        (click)="closeTransferDialog()"
        class="btn btn-circle btn-ghost btn-sm absolute right-2 top-2"
      >
        ✕
      </button>
    </form>

    <h3 class="text-lg font-bold">Transfer License</h3>

    @if (sameUidLicensesList.length > 0) {
      <p class="mt-4 text-base font-medium">
        Transfer other licenses with same Unique ID?
      </p>
      <div class="mt-2 overflow-x-auto rounded-lg border border-base-content/20">
        <table class="table table-sm">
          <thead>
            <tr>
              <th></th>
              <th>Product</th>
              <th>Type</th>
              <th>Transfers left</th>
              <th>Expiration</th>
            </tr>
          </thead>
          <tbody>
            @for (license of sameUidLicensesList; track license.id) {
              <tr>
                <td>
                  <input
                    type="checkbox"
                    class="checkbox"
                    [checked]="sameUidSelected.has(license.id)"
                    (change)="
                      setSameUidSelected(
                        license.id,
                        $any($event.target).checked
                      )
                    "
                  />
                </td>
                <td class="max-w-xs break-words">
                  {{ license.product.code }} — {{ license.product.title }}
                </td>
                <td>{{ getLicenseType(license) }}</td>
                <td>{{ license.transfers_left }}</td>
                <td>
                  {{ license.expiration | date: 'MM/dd/YYYY' : 'UTC' }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    <hr class="my-8 border-base-content/50" />

    <div class="mt-4">
      <span class="mr-2 text-base">Current Unique ID:</span>
      <span class="text-base">
        {{ licenseToTransfer?.activation_key?.unique_id || 'None' }}
      </span>
    </div>

    <div class="form-control mt-2">
      <label class="label">
        <span class="label-text">Enter a new Unique ID</span>
      </label>
      <input
        #newUniqueIdInput
        type="text"
        class="input input-bordered"
        placeholder="New Unique ID"
        [(ngModel)]="newUniqueId"
        (input)="clearSelectedTransferMachineId()"
      />
    </div>

    @if (transferLoadingMachines) {
      <div class="skeleton mb-4 mt-8 h-12 w-full"></div>
    } @else if (transferErrorLoadingMachines) {
      <div class="mt-2">
        <div class="text-base text-error">
          {{ transferErrorLoadingMachines }}
        </div>
      </div>
    } @else {
      @if (transferDistinctActiveMachinesList.length > 0) {
        <div
          class="mb-2 mt-4 flex w-full items-center justify-center gap-2"
        >
          <div class="h-0 flex-grow border-b border-base-content/50"></div>
          <span class="shrink-0 text-base-content/70">&nbsp;OR&nbsp;</span>
          <div class="h-0 flex-grow border-b border-base-content/50"></div>
        </div>

        <div class="form-control">
          <label class="label pt-0">
            <span class="label-text">Select existing machine</span>
          </label>
          <ul
            class="mt-2 max-h-60 divide-y divide-base-content/50 overflow-y-auto rounded-lg border border-base-content/20"
            role="radiogroup"
            aria-label="Active registrations by unique ID"
          >
            @for (
              machine of transferDistinctActiveMachinesList;
              track machine.registration_id
            ) {
              <li>
                <label
                  class="flex cursor-pointer items-start gap-3 px-3 py-2.5 hover:bg-base-200"
                >
                  <input
                    type="radio"
                    name="transferRegistrationPickCustomer"
                    class="radio-primary radio mt-0.5 shrink-0"
                    [checked]="isRegistrationSelected(machine)"
                    (change)="selectRegistrationForTransfer(machine)"
                  />
                  <span class="min-w-0 flex-1 text-base">
                    <span class="font-medium">{{ machine.uniqueid }}</span>
                    @if (machine.computername) {
                      <span class="text-base-content/80">
                        — {{ machine.computername }}
                      </span>
                    }
                    @if (machine.lastused) {
                      <span
                        class="mt-0.5 block text-sm text-base-content/70"
                      >
                        Last used:
                        {{ machine.lastused | date: 'MM/dd/YYYY, hh:mmaa' }}
                      </span>
                    }
                  </span>
                </label>
              </li>
            }
          </ul>
        </div>
      }
    }

    <div class="modal-action">
      @if (transferingLicense) {
        <div class="loading-spinner mr-4"></div>
      }
      <button
        type="button"
        (click)="transferLicense()"
        class="btn btn-primary"
        [disabled]="transferingLicense"
      >
        Transfer
      </button>
      <button
        type="button"
        class="btn btn-secondary"
        (click)="closeTransferDialog()"
        [disabled]="transferingLicense"
      >
        Cancel
      </button>
      @if (errorTransferingLicense) {
        <div class="mt-2 text-base text-error">
          {{ errorTransferingLicense }}
        </div>
      }
    </div>
  </div>
  <form method="dialog" class="modal-backdrop">
    <button type="submit">close</button>
  </form>
</dialog>

@if (licenses.pending.length > 0) {
  <div class="pt-12">
    <div class="prose">
      <h2 class="mb-4 ml-6">Pending</h2>
    </div>
    <div
      class="overflow-hidden rounded-lg border border-base-content/20"
    >
      <div class="divide-y divide-base-300">
        @for (
          license of licenses.pending;
          track license.id;
          let i = $index
        ) {
          <article
            class="license-row px-4 py-4"
            [ngClass]="{ 'bg-base-200': i % 2 === 0 }"
          >
            <div
              class="grid min-w-0 flex-1 grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6"
            >
              <div class="col-span-2 min-w-0 lg:col-span-4 xl:col-span-2">
                <div class="field-label">Product</div>
                <div class="break-words text-base font-medium">
                  {{ license.product.code }} -
                  {{ license.product.title }} ({{
                    license.product.variance_code
                  }})
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Type</div>
                <div class="break-words text-base">
                  {{ getLicenseType(license) }}
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Duration</div>
                <div class="break-words text-base">
                  {{ license.product_variant.display_duration }}
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Expiration</div>
                <div
                  class="break-words text-base"
                  [ngClass]="{ 'text-error': license.close_to_expiration }"
                >
                  {{ license.expiration | date: 'MM/dd/YYYY' : 'UTC' }}
                </div>
              </div>

              <div class="col-span-2 min-w-0">
                <div class="field-label">
                  Activation Key
                  @if (license.activation_key) {
                    @if (shownKeys.has(license.id)) {
                      <app-eye-slash-icon
                        (click)="shownKeys.delete(license.id)"
                        class="mb-[-4px] ml-2 inline-block h-4 w-4 cursor-pointer"
                      />
                    } @else {
                      <app-eye-icon
                        (click)="shownKeys.add(license.id)"
                        class="mb-[-4px] ml-2 inline-block h-4 w-4 cursor-pointer"
                      />
                    }
                  }
                </div>
                <div class="break-words text-base">
                  @if (license.activation_key) {
                    @if (shownKeys.has(license.id)) {
                      <span class="text-nowrap text-sm">{{
                        license.activation_key.activation_key
                      }}</span>
                    } @else {
                      <span [innerHTML]="hiddenKeyString"></span>
                    }
                  } @else {
                    <span class="text-base italic">None</span>
                  }
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Unique ID</div>
                <div class="break-words text-base">
                  @if (license.activation_key) {
                    {{ license.activation_key.unique_id || '—' }}
                  } @else {
                    <span class="text-base italic">None</span>
                  }
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Transfers Left</div>
                <div class="break-words text-base">
                  {{ license.transfers_left }}
                </div>
              </div>
            </div>
          </article>
        }
      </div>
    </div>
  </div>
}

@if (licenses.expired.length > 0) {
  <div class="pt-12">
    <div class="prose">
      <h2 class="mb-4 ml-6">Expired</h2>
    </div>
    <div
      class="overflow-hidden rounded-lg border border-base-content/20"
    >
      <div class="divide-y divide-base-300">
        @for (
          license of licenses.expired;
          track license.id;
          let i = $index
        ) {
          <article
            class="license-row px-4 py-4"
            [ngClass]="{ 'bg-base-200': i % 2 === 0 }"
          >
            <div
              class="grid min-w-0 flex-1 grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6"
            >
              <div class="col-span-2 min-w-0 lg:col-span-4 xl:col-span-2">
                <div class="field-label">Product</div>
                <div class="break-words text-base font-medium">
                  {{ license.product.code }} -
                  {{ license.product.title }} ({{
                    license.product.variance_code
                  }})
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Type</div>
                <div class="break-words text-base">
                  {{ getLicenseType(license) }}
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Duration</div>
                <div class="break-words text-base">
                  {{ license.product_variant.display_duration }}
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Expiration</div>
                <div class="break-words text-base">
                  {{ license.expiration | date: 'MM/dd/YYYY' : 'UTC' }}
                </div>
              </div>

              <div class="col-span-2 min-w-0">
                <div class="field-label">
                  Activation Key
                  @if (license.activation_key) {
                    @if (shownKeys.has(license.id)) {
                      <app-eye-slash-icon
                        (click)="shownKeys.delete(license.id)"
                        class="mb-[-4px] ml-2 inline-block h-4 w-4 cursor-pointer"
                      />
                    } @else {
                      <app-eye-icon
                        (click)="shownKeys.add(license.id)"
                        class="mb-[-4px] ml-2 inline-block h-4 w-4 cursor-pointer"
                      />
                    }
                  }
                </div>
                <div class="break-words text-base">
                  @if (license.activation_key) {
                    @if (shownKeys.has(license.id)) {
                      <span class="text-nowrap text-sm">{{
                        license.activation_key.activation_key
                      }}</span>
                    } @else {
                      <span [innerHTML]="hiddenKeyString"></span>
                    }
                  } @else {
                    <span class="text-base italic">None</span>
                  }
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Unique ID</div>
                <div class="break-words text-base">
                  @if (license.activation_key) {
                    {{ license.activation_key.unique_id || '—' }}
                  } @else {
                    <span class="text-base italic">None</span>
                  }
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Transfers Left</div>
                <div class="break-words text-base">
                  {{ license.transfers_left }}
                </div>
              </div>
            </div>
          </article>
        }
      </div>
    </div>
  </div>
}

@if (licenses.disabled.length > 0) {
  <div class="pt-12">
    <div class="prose">
      <h2 class="mb-4 ml-6">Disabled</h2>
    </div>
    <div
      class="overflow-hidden rounded-lg border border-base-content/20"
    >
      <div class="divide-y divide-base-content/50">
        @for (
          license of licenses.disabled;
          track license.id;
          let i = $index
        ) {
          <article
            class="license-row px-4 py-4"
            [ngClass]="{ 'bg-base-200': i % 2 === 0 }"
          >
            <div
              class="grid min-w-0 flex-1 grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6"
            >
              <div class="col-span-2 min-w-0 lg:col-span-4 xl:col-span-2">
                <div class="field-label">Product</div>
                <div class="break-words text-base font-medium">
                  {{ license.product.code }} -
                  {{ license.product.title }} ({{
                    license.product.variance_code
                  }})
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Type</div>
                <div class="break-words text-base">
                  {{ getLicenseType(license) }}
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Duration</div>
                <div class="break-words text-base">
                  {{ license.product_variant.display_duration }}
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Expiration</div>
                <div class="break-words text-base">
                  {{ license.expiration | date: 'MM/dd/YYYY' : 'UTC' }}
                </div>
              </div>

              <div class="col-span-2 min-w-0">
                <div class="field-label">
                  Activation Key
                  @if (license.activation_key) {
                    @if (shownKeys.has(license.id)) {
                      <app-eye-slash-icon
                        (click)="shownKeys.delete(license.id)"
                        class="mb-[-4px] ml-2 inline-block h-4 w-4 cursor-pointer"
                      />
                    } @else {
                      <app-eye-icon
                        (click)="shownKeys.add(license.id)"
                        class="mb-[-4px] ml-2 inline-block h-4 w-4 cursor-pointer"
                      />
                    }
                  }
                </div>
                <div class="break-words text-base">
                  @if (license.activation_key) {
                    @if (shownKeys.has(license.id)) {
                      <span class="text-nowrap text-sm">{{
                        license.activation_key.activation_key
                      }}</span>
                    } @else {
                      <span [innerHTML]="hiddenKeyString"></span>
                    }
                  } @else {
                    <span class="text-base italic">None</span>
                  }
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Unique ID</div>
                <div class="break-words text-base">
                  @if (license.activation_key) {
                    {{ license.activation_key.unique_id || '—' }}
                  } @else {
                    <span class="text-base italic">None</span>
                  }
                </div>
              </div>

              <div class="min-w-0">
                <div class="field-label">Transfers Left</div>
                <div class="break-words text-base">
                  {{ license.transfers_left }}
                </div>
              </div>
            </div>
          </article>
        }
      </div>
    </div>
  </div>
} -->